var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12 14V8","key":0}),React.createElement("path",{"fill":"#737680","stroke":"#737680","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12.5 18c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5 0-.277.223-.5.5-.5.276 0 .5.223.5.5z","key":1}),React.createElement("path",{"stroke":"#737680","strokeWidth":"1.5","d":"M9.353 2.692c1.177-2.256 4.117-2.256 5.293 0l7.94 15.231C23.762 20.18 22.292 23 19.94 23H4.06c-2.352 0-3.822-2.82-2.646-5.077l7.94-15.23z","key":2})]);
}

Alert.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Alert;

Alert.default = Alert;
